
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_14457_21214)"}},[_c('path',{attrs:{"d":"M15 7.553L7.554 15 0 7.446 7.447 0l4.139 4.139-3.95 4.028-1.546-1.51-.205-.201-.207.2-1.246 1.216-.215.209.212.21 2.954 2.945.21.21.208-.211 5.419-5.462L15 7.553z","fill":"url(#paint0_linear_14457_21214)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_14457_21214","x1":"0","y1":"7.5","x2":"15","y2":"7.5","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FF2545"}}),_c('stop',{attrs:{"offset":".06","stop-color":"#F42651"}}),_c('stop',{attrs:{"offset":".38","stop-color":"#C52F88"}}),_c('stop',{attrs:{"offset":".65","stop-color":"#A234B0"}}),_c('stop',{attrs:{"offset":".87","stop-color":"#8D38C8"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#863AD2"}})]),_c('clipPath',{attrs:{"id":"clip0_14457_21214"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15v15H0z"}})])])])
          )
        }
      }
    